export default "__VITE_ASSET__BbHkhq5e__"